import _get from 'lodash/get'
import { parseDate } from '@/utilities/Date/parse'
import Button from '@/components/buttons/Button'
import { lotFileDocumentStore } from '@/services/LotFileDocument/store'
import Download from '@/pages/Management/units/tabs/Documents/keys/components/Download'
import { notifyWarning, notifyProblem, notifyError, notifyMessage } from '@/services/notify'

export const defaultDateFormat = 'MM/dd/yyyy'

export const methods = {
  async updateRows() {
    const dateFormat = 'LL'

    this.rows = this.documentList.map(row => {
      const dateSubmitted = parseDate(_get(row, 'createdDate', ''), dateFormat)

      const id = _get(row, 'lotFileDocumentID', 0)
      const documentId = _get(row, 'documentID', 0)
      const category = _get(row, 'lotFileCategory.name', '')
      const description = _get(row, 'description', '')

      return {
        id,
        category,
        description,
        dateSubmitted: {
          date: dateSubmitted,
          format: dateFormat
        },
        detail: {
          component: Button,
          props: {
            onClick: async () => {
              this.selectedDocument = this.documentList.find(v => {
                return v.lotFileDocumentID === id
              })

              await this.loadDetails(id)
            },
            text: 'Edit'
          }
        },
        delete: {
          component: Button,
          props: {
            onClick: async () => {
              await this.confirmDeleteLotFile(id, description)
            },
            text: 'Delete'
          }
        },
        document: {
          component: Download,
          props: {
            documentID: documentId,
            lotFileDocumentID: id,
            downloadPdf: lotFileDocumentID => {
              this.selectedDocument = this.documentList.find(v => {
                return v.lotFileDocumentID === id
              })

              console.debug('download id=' + id + ', ' + documentId + ', ' + lotFileDocumentID)
              this.downloadPdf(lotFileDocumentID)
            }
          }
        }
      }
    })

    await this.getCategories()
  },

  async confirmDeleteLotFile(id, description) {
    try {
      this.$buefy.dialog.confirm({
        title: 'Deleting Lot File Document',
        message: `Are you sure you want to <b>delete</b> this document for '${description || ''}'?`,
        confirmText: 'Delete Lot File Document',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => await this.deleteLotFileDocument(id)
      })
    } catch (e) {
      console.debug('There was an issue deleting this lot file document.')
    }
  },

  async deleteLotFileDocument(id) {
    this.loading = true
    try {
      await lotFileDocumentStore.dispatch('deleteLotFileDocument', {
        lotFileDocumentID: id,
        done: async () => {
          this.loading = false
          this.selectedID = null
          this.formShow = false
          this.action = ''
          await this.getCategories()
          this.file = null

          await this.getRefreshedLotFileDocuments()

          this.reRender()
        }
      })
    } catch (e) {
      console.debug('There was an issue deleting this hoa contact.' + e)
      this.loading = false
    }
    this.loading = false
  },

  async resetForm() {
    this.loading = true
    const DEFAULT_FORM_VALUES = this.DEFAULT_FORM_VALUES
    this.formData = { ...DEFAULT_FORM_VALUES }
    if (this.$refs.form) {
      this.$refs.form.reset()
    }

    this.loading = false
  },

  openDocumentModal() {
    this.resetForm()
    this.selectedID = null
    // this.formShow = !this.formShow
    this.action = 'Update'
    this.showModal = true
  },

  async loadDetails(id) {
    this.resetForm()
    this.selectedID = null
    this.showModal = true
    this.action = 'Update'

    console.debug('loadDetails=' + JSON.stringify(this.selectedDocument))

    if (this.selectedDocument && this.selectedDocument != undefined) {
      this.formData.lotFileDocumentID = this.selectedDocument.lotFileDocumentID
      this.formData.lotFileCategoryID = this.selectedDocument.lotFileCategoryID
      this.formData.address = this.parsedAddress(this.selectedDocument.unit.address)
      this.formData.owner = this.selectedDocument.owner.name
      this.formData.category = this.selectedDocument.lotFileCategory.name
      this.formData.documentID = this.selectedDocument.documentID
      this.formData.description = this.selectedDocument.description || ''
    }

    this.selectedID = id
    this.formShow = true
    this.action = 'Update'

    this.showModal = true
  },

  async initButtons() {
    this.selectedID = null
    this.formShow = false
    this.action = ''
    await this.getCategories()
    this.file = null
  },

  // api calls
  async getRefreshedLotFileDocuments() {
    console.debug('in getRefreshedLotFileDocuments...' + this.unitID + ', ' + this.ownerID)
    if (this.unitID != undefined && this.unitID && this.ownerID !== undefined && this.ownerID) {
      await lotFileDocumentStore
        .dispatch('getLotFileDocumentList', {
          unitID: this.unitID,
          ownerID: this.ownerID,
          includeSignedUrls: true
        })
        .then(async ({ list }) => {
          this.documentList = list
          await this.initButtons()
        })
    }
  },

  async getCategories() {
    this.categoryList = []

    await lotFileDocumentStore
      .dispatch('getLotFileCategoryList', {
        hoaID: this.hoaId
      })
      .then(async ({ list }) => {
        console.debug('getCategories list=' + JSON.stringify(list))
        if (list) {
          let myList = []

          list.forEach(f => {
            if (f && f.name !== undefined) {
              const filterCategory = {
                label: f.name || '',
                value: f.lotFileCategoryID,
                filter: ''
              }

              if (f.name !== '') {
                myList.push(filterCategory)
              }
            }
          })
          this.categoryList = myList
        }
      })
  },

  zoom(direction) {
    const amt = Math.sqrt(2)
    if (direction > 0) {
      this.scale *= amt
    } else {
      this.scale /= amt
    }

    // constrain to min/max
    this.scale = Math.max(0.5, Math.min(4, this.scale))
  },

  closeModal() {
    this.resetForm()
    this.selectedID = null
    this.showModal = false
    this.base64pdf = ''
    this.action = ''
    this.file = null
  },

  async replaceFile() {
    await this.submitLotFileDocument().then(async () => {
      if (
        this.selectedDocument.documentURL !== undefined &&
        this.selectedDocument.documentURL &&
        this.file !== undefined &&
        this.file
      ) {
        const payload = {
          lotFileDocumentID: this.selectedDocument.lotFileDocumentID,
          file: this.file
        }

        await lotFileDocumentStore.dispatch('uploadDocument', {
          payload: payload,
          done: async ({ returnedFile }) => {
            if (returnedFile) {
              this.resetForm()
              this.selectedID = null
              this.showModal = false
              await this.getRefreshedLotFileDocuments()
              this.file = null
              this.loading = false
              this.base64pdf = ''
              this.action = ''

              notifyMessage(`Successfully replaced the document.`)

              this.reRender()
            } else {
              notifyError('There was a problem replacing this document.')
            }
          }
        })
      }
    })
  },

  reRender() {
    //Necessary for now to force other tabs to re-render
    this.$forceUpdate()
    this.$router.go(0)
  },

  async submitFile() {
    console.debug('in submitFile...')
    try {
      if (this.file !== undefined && this.file) {
        if (
          this.selectedDocument.lotFileDocumentID === undefined ||
          !this.selectedDocument.lotFileDocumentID
        ) {
          await this.submitAddLotFileDocument()
        }

        if (this.selectedDocument.lotFileDocumentID || this.selectedID) {
          const payload = {
            lotFileDocumentID: this.selectedDocument.lotFileDocumentID || this.selectedID,
            file: this.file
          }

          await lotFileDocumentStore.dispatch('uploadDocument', {
            payload: payload,
            done: async ({ returnedFile }) => {
              if (returnedFile) {
                this.resetForm()
                this.selectedID = null
                this.showModal = false
                this.loading = false
                this.file = null
                notifyMessage(`Successfully added the document.`)
              } else {
                notifyError('There was a problem adding this document.')
              }

              setTimeout(async () => await this.getRefreshedLotFileDocuments(), 1000)

              this.reRender()
            }
          })
        }
      }
    } catch (error) {
      console.debug('an errror ocurred in submitFile...' + error)
    }
  },

  async submitLotFile() {
    console.debug('submitLotFile...')
    if (this.action === 'Add') {
      await this.submitAddLotFileDocument()
    } else {
      await this.submitLotFileDocument()
    }
  },

  async addLotFileDocument() {
    console.debug('in addLotFileDocument()...')

    this.resetForm()
    this.selectedID = null
    this.showModal = true
    this.base64pdf = ''
    this.action = 'Add'
    this.file = null
    if (this.selectedDocument !== undefined && this.selectedDocument.documentURL !== undefined) {
      this.selectedDocument.documentURL = null
    }

    this.formData.address = this.parsedAddress(this.defaultAddress)
    this.formData.owner = this.defaultOwnerName
  },

  async downloadPdf(lotFileDocumentID) {
    if (this.isDebug == true) console.debug('downloadPdf...')

    if (!lotFileDocumentID || lotFileDocumentID == undefined) {
      notifyProblem('The lot file document does not exist.')
      return
    }

    try {
      const path = this.selectedDocument.documentURL

      console.debug(path + ', ' + JSON.stringify(this.selectedDocument.documentURL))

      //NOTE: the getSigned endpoint must have a Content-Disposition: inline, for this to populate the tab
      var link = document.createElement('a')
      link.download = 'download.pdf'
      link.setAttribute('download', 'download.pdf')
      link.href = this.selectedDocument.documentURL
      window.open(link, '_blank')
    } catch (e) {
      console.debug(e)
      notifyWarning('There was a problem downloading the lot file document.')
    }
  },

  async submitAddLotFileDocument() {
    if (this.formData === undefined || !this.formData) {
      notifyProblem(
        'Unable to add this lot file document. Please refresh your screen and try again.'
      )
      return
    }

    if (this.formData.lotFileCategoryID === undefined || !this.formData.lotFileCategoryID) {
      notifyProblem('Please select a category.')
      return
    }

    if (this.formData.description === undefined || !this.formData.description) {
      notifyProblem('Please enter a description.')
      return
    }

    try {
      this.loading = true
      const payload = {
        lotFileCategoryID: this.formData.lotFileCategoryID,
        ownerID: this.ownerID,
        addressID: this.addressID,
        unitID: this.unitID,
        documentID: null,
        description: this.formData.description,
        hoaID: this.hoaId
      }

      await lotFileDocumentStore.dispatch('createLotFileDocument', {
        payload: payload,
        done: async ({ detail }) => {
          console.debug('response lotFileDocumentID=' + detail.lotFileDocumentID)
          if (detail) {
            this.resetForm()
            this.selectedID = detail.lotFileDocumentID
            this.showModal = false
            await this.getRefreshedLotFileDocuments()
          }
          this.loading = false

          this.reRender()
        }
      })
    } catch (e) {
      console.debug(e)
      notifyWarning('There was a problem adding the lot file document.')
    }

    this.loading = false
  },

  async submitLotFileDocument() {
    console.debug('in submitLotFileDocument...')

    if (this.formData === undefined || !this.formData) {
      notifyProblem(
        'Unable to update this lot file document. Please refresh your screen and try again.'
      )
      return
    }

    if (this.formData.lotFileDocumentID === undefined || !this.formData.lotFileDocumentID) {
      notifyProblem(
        'Unable to update this lot file document. Please refresh your screen and try again.'
      )
      return
    }

    if (this.formData.lotFileCategoryID === undefined || !this.formData.lotFileCategoryID) {
      notifyProblem('Please select a category.')
      return
    }

    if (this.formData.description === undefined || !this.formData.description) {
      notifyProblem('Please enter a description.')
      return
    }

    try {
      this.loading = true
      const payload = {
        lotFileDocumentID: this.selectedDocument.lotFileDocumentID,
        lotFileCategoryID: this.formData.lotFileCategoryID,
        ownerID: this.selectedDocument.ownerID,
        addressID: this.selectedDocument.addressID,
        unitID: this.selectedDocument.unitID,
        documentID: this.selectedDocument.documentID,
        description: this.formData.description,
        hoaID: this.hoaId
      }

      await lotFileDocumentStore.dispatch('updateLotFileDocument', {
        payload: payload,
        done: async () => {
          this.resetForm()
          this.selectedID = null
          this.showModal = false
          await this.getRefreshedLotFileDocuments()
          this.loading = false

          this.reRender()
        }
      })
    } catch (e) {
      console.debug(e)
      notifyWarning('There was a problem updating the lot file document.')
    }

    this.loading = false
  }
}
